import React from "react";
import { TnSkeleton } from "../components/TnSkeleton";
import InfoTooltip from "../components/InfoTooltip";
import { clickableProps } from "../components/clickable";

/*
Block 6 - the SLA workflow cards, from the same case-snapshot request as
block 5. Do not fetch again here.

A count of 0 is a valid, good state - it renders as 0 with the tint dropped to
neutral rather than as an empty state.
*/
const CARDS = [
  {
    key: "no_response_48h",
    icon: "⏱",
    title: "No response in 48h",
    sub: "awaiting first action",
    tone: "breach",
    tooltip: "Tickets that have had no agent action in the last 48 hours.",
  },
  {
    key: "blocked",
    icon: "⏸",
    title: "On Hold tickets",
    sub: "awaiting parts, quote, response or approval",
    tone: "blocked",
    tooltip:
      "Tickets in Awaiting Parts, Awaiting quotation acceptance, Awaiting store/customer response or Awaiting approval. Not counted towards no response.",
  },
  {
    key: "unresolved_past_sla",
    icon: "⚠",
    title: "Unresolved past SLA",
    sub: "open beyond due date",
    tone: "breach",
    tooltip: "Tickets still open past their SLA due date.",
  },
];

const NeedsAttentionSection = function (props) {
  const { resource, activeFilterId, onSelectFilter } = props;
  const sla = (resource.data && resource.data.sla) || null;
  const filters = (resource.data && resource.data.filters) || null;
  const loading = resource.loading && !resource.hasLoadedOnce;

  // The shared error is already surfaced by CaseSnapshotSection; don't repeat it.
  if (resource.error) return null;

  return (
    <div className="tn-attention">
      <div className="tn-eyebrow-row">
        <span className="tn-eyebrow">Needs attention</span>
        <span className="tn-eyebrow-muted">SLA workflows</span>
      </div>
      <div className="tn-attention-row">
        {CARDS.map(function (card) {
          const count = sla ? sla[card.key] : null;
          const hasCount = count !== null && count !== undefined;
          const tone = hasCount && count === 0 ? "calm" : card.tone;
          // Click-to-filter, keyed into the same response's `filters`.
          const id = "snapshot:" + card.key;
          const clickable = !!(onSelectFilter && filters && filters[card.key]);
          const active = clickable && activeFilterId === id;
          return (
            <div
              className={
                "tn-attention-card tn-attention-" +
                tone +
                (clickable ? " tn-clickable" : "") +
                (active ? " tn-clickable-active" : "")
              }
              key={card.key}
              {...clickableProps(
                clickable
                  ? function () {
                      onSelectFilter(id);
                    }
                  : null,
                active
              )}
            >
              <InfoTooltip text={card.tooltip} />
              <div className="tn-attention-head">
                <span className="tn-attention-icon" aria-hidden="true">
                  {card.icon}
                </span>
                <span className="tn-attention-title">{card.title}</span>
              </div>
              <div className="tn-attention-body">
                {loading ? (
                  <TnSkeleton w="48px" h="28px" />
                ) : (
                  <span className="tn-attention-count">
                    {hasCount ? count : "—"}
                  </span>
                )}
                <span className="tn-attention-sub">{card.sub}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NeedsAttentionSection;
